import { NewAntragInfos } from "../../../../model/foerderantraege.model";
import { AntragsnummerDto } from "../../generated";

export const mapNewAntragInfos = (antragsnummerDTO: Required<AntragsnummerDto>): NewAntragInfos => {
    return {
        antragsId: antragsnummerDTO.id,
        antragsnummer: antragsnummerDTO.antragsnummer
    } as NewAntragInfos
}